import styled from '@emotion/styled';
import css from '@styled-system/css';

import Flex from '../../layouts/Flex';

const DARK = 'dark';

const Line = styled(Flex)(
  css({
    position: 'absolute',
    width: '0px',
    borderColor: 'decorationLine.default',
    borderLeftWidth: '1px',
    borderRightWidth: '0',
    height: 'decorationLine.height',
    top: '0px',
    left: '50%',
    transform: 'translateX(-50%)',
  }),
  ({ color, lineGrey }) =>
    css({
      borderColor:
        lineGrey === false
          ? color === DARK
            ? 'decorationLine.default'
            : `decorationLine.${color}`
          : 'decorationLine.grey',
    }),
  ({ type }) =>
    css({
      borderStyle: type,
    }),
  ({ iconBackground }) =>
    css({
      top: !iconBackground && '22px',
      height: !iconBackground && 'calc(100% - 15px)',
    }),
  ({ alignTop }) =>
    css({
      height: alignTop && 'decorationLine.topLineHeight',
    }),
  ({ lineBottom }) =>
    css(
      (lineBottom && {
        bottom: lineBottom,
        height: 'unset',
      }) ||
        {}
    )
);

export default Line;
